<template>
  <div class="mobile-wrapper bg-white">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="navigateToOrder"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="navigateToOrder">Back</span>
          </div>
        </div>
      </div>
      <!-- /banner -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="bg-white pt-4 mt-4">
            <div class="pt-4 mt-4 d-flex justify-content-center">
              <div class="w-85 text-center thank-div">
                <h2 class="d-flex justify-content-center align-items-center">
                  <span class="material-icons">check_circle</span>
                  {{ $t("message.thankYou") }}
                </h2>
                <p>{{ message }}</p>
                <br />
                <div class="row">
                  <div class="col-sm-12">
                    <button
                      type="button"
                      class="btn btn-primary pr-2 btn-with-margins"
                      @click="continueOrder"
                    >
                      {{ $t("message.continueOrdering") }}
                    </button>
                    <button
                      v-show="
                        !isGift && !user && viewConfig.LogIn && this.isBranded()
                      "
                      type="button"
                      class="btn btn-primery btn-with-margins"
                      @click="GoRegister"
                    >
                      {{ $t("message.becomeMember") }}
                    </button>
                  </div>
                </div>
                <poweredby />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import poweredby from "../../shared/poweredby";
export default {
  components: {
    poweredby,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    isGift: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["viewConfig", "user", "getThankYouMessage"]),
    message() {
      return this.getThankYouMessage;
    },
  },
  mounted() {
    if (window.location.href.indexOf("/giftcards/") != -1) {
      this.isGift = true;
    }
  },
  methods: {
    navigateToOrder() {
      if (this.isGift) {
        this.$router.push({
          name: "giftstorev2",
          params: {
            storeid: this.storeid,
            storename: this.$route.params.storename,
          },
        });
      } else {
        this.$router.push({
          name: "store",
          params: { storeid: this.storeid },
        });
      }
    },
    continueOrder() {
      if (this.isGift)
        this.$router.push({
          name: "giftstorev2",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      else
        this.$router.push({
          name: "store",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
    },
    GoRegister() {
      this.$router.push("/Register");
    },
  },
};
</script>
